import { createWebHistory, createRouter } from "vue-router";
import Login from "../page/LoginPage.vue";
import Company from "../page/CompanyPage.vue";
import Factory from "../page/FactoryPage.vue";
import Workshop from '../page/WorkshopPage.vue';
import EquipmentAdd from '../page/EquipmentAddPage.vue';
import EquipmentList from '../page/EquipmentListPage.vue';
import CreateQR from '../page/Instructions/CreateQRPage.vue';
import InstructionsList from '../page/Instructions/InstructionsListPage.vue';
import EditQR from '../page/Instructions/EditQRPage.vue';

const routes = [
  {
    path: "/",
    name: "Home",
    component: EquipmentList,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/company",
    name: "Company",
    component: Company,
  },
  {
    path: "/factory",
    name: "Factory",
    component: Factory,
  },
  {
    path: "/workshop",
    name: "Workshop",
    component: Workshop,
  },
  {
    path: "/equipmentAdd",
    name: "EquipmentAdd",
    component: EquipmentAdd,
  },
  {
    path: "/equipmentList",
    name: "EquipmentList",
    component: EquipmentList,
  },
  {
    path: "/instructions/createQR",
    name: "CreateQR",
    component: CreateQR,
  },
  {
    path: "/instructions/instructionsList",
    name: "InstructionsList",
    component: InstructionsList,
  },
  {
    path: "/instructions/editQR",
    name: "EditQR",
    component: EditQR,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  if (
    // 检查用户是否已登录
    !localStorage.getItem('SEBackstage') &&
    // ❗️ 避免无限重定向
    to.name !== 'Login'
  ) {
    // 将用户重定向到登录页面
    return { name: 'Login' }
  }
})

export default router;